module.exports = __webpack_public_path__ + "static/media/picasso-8.95fa7f25.jpeg";